import { createFileRoute } from '@tanstack/react-router'
import { Suspense, lazy, useState } from 'react'
import { ClientOnly } from '@tanstack/react-router'
import { useTideData } from '~/hooks/useTideData'

// Leaflet reads `window` while its module is evaluated, so it must stay out of
// the server bundle entirely. ClientOnly only defers rendering — the lazy()
// boundary is what keeps the import off the server.
const MapComponent = lazy(() => import('~/components/WaterLevelMap'))

export const Route = createFileRoute('/water-level')({
  component: HomePage,
})

const MapFallback = () => (
  <div className="h-screen w-full flex items-center justify-center">
    <div className="text-lg">Loading map...</div>
  </div>
)

function HomePage() {
  const [selectedStationId, setSelectedStationId] = useState<string | null>(null)
  const [selectedStationName, setSelectedStationName] = useState('')

  const { data: tideData, isLoading: isTideLoading, error: tideError } = useTideData(
    selectedStationId,
    { days: 7, enabled: !!selectedStationId }
  )

  const handleStationClick = (stationId: string, stationName: string) => {
    setSelectedStationId(stationId)
    setSelectedStationName(stationName)
  }
  return (
    <div className="h-screen w-full">
      {/* {import.meta.env.DEV && <DebugMSW />} */}
      <ClientOnly fallback={<MapFallback />}>
        <Suspense fallback={<MapFallback />}>
          <MapComponent />
        </Suspense>
      </ClientOnly>
    </div>
  )
}
